import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { factures as fx, eur, eur0, dfr } from './pilotageApi';

const STATUT_BADGE = { reglee: 'bg-g', partielle: 'bg-a', en_attente: 'bg-b', en_retard: 'bg-r', annulee: 'bg-n', avoir: 'bg-n' };
const TYPE_FILTERS = [
  { k: 'toutes', l: 'Toutes' }, { k: 'acomptes', l: 'Acomptes' },
  { k: 'finales', l: 'Finales' }, { k: 'avoirs', l: 'Avoirs' },
];
const STATUT_FILTERS = [
  { k: 'toutes', l: 'Tous statuts' }, { k: 'reglees', l: 'Réglées' },
  { k: 'en_attente', l: 'En attente' }, { k: 'en_retard', l: 'En retard' },
];

export default function Factures() {
  const nav = useNavigate();
  const [tab, setTab] = useState('factures');
  const [data, setData] = useState(null);
  const [imp, setImp] = useState(null);
  const [err, setErr] = useState(null);
  const [flash, setFlash] = useState(null);
  const [busy, setBusy] = useState(false);
  const [modal, setModal] = useState(null); // {kind, facture}
  const [anomalies, setAnomalies] = useState(null);
  const [f, setF] = useState({ type: 'toutes', statut: 'toutes', q: '', date_from: '', date_to: '', page: 1 });
  const [exp, setExp] = useState({ date_from: '', date_to: '', format: 'csv', email: '' });

  const say = (m) => { setFlash(m); setTimeout(() => setFlash(null), 3000); };

  const load = useCallback(() => {
    fx.list(f).then(setData).catch((e) => { if (e.code === 401 || e.code === 403) nav('/connexion'); else setErr(e.message); });
    fx.impayes().then(setImp).catch(() => {});
    fx.anomalies().then(setAnomalies).catch(() => {});
  }, [f, nav]);
  useEffect(() => { load(); }, [load]);

  async function run(fn, msg) {
    setBusy(true);
    try { await fn(); say(msg); setModal(null); load(); }
    catch (e) { say(`⚠️ ${e.detail || e.message}`); }
    finally { setBusy(false); }
  }

  if (err) return <div className="wrap"><div className="nt ba">{err}</div></div>;
  if (!data) return <div className="load" data-testid="factures-loading">Chargement des factures…</div>;

  const c = data.compteurs;

  return (
    <>
      <div className="top">
        <h1>Factures</h1>
        <span className="ctx mono">{data.total} document{data.total > 1 ? 's' : ''}</span>
        <div className="sp" />
        <input type="date" data-testid="exp-from" value={exp.date_from} onChange={(e) => setExp({ ...exp, date_from: e.target.value })} title="Début période export" />
        <input type="date" data-testid="exp-to" value={exp.date_to} onChange={(e) => setExp({ ...exp, date_to: e.target.value })} title="Fin période export" />
        <select data-testid="exp-format" value={exp.format} onChange={(e) => setExp({ ...exp, format: e.target.value })}>
          <option value="csv">CSV</option>
          <option value="xlsx">Excel (XLSX)</option>
        </select>
        <button className="btn btn-p" data-testid="btn-export-comptable" disabled={busy}
          onClick={() => run(() => fx.exportFile({ date_from: exp.date_from, date_to: exp.date_to, format: exp.format }), 'Export comptable téléchargé.')}>⭳ Export comptable</button>
        <input type="email" data-testid="exp-email" value={exp.email} placeholder="e-mail comptable (optionnel)"
          style={{ minWidth: 200 }}
          onChange={(e) => setExp({ ...exp, email: e.target.value })} title="Destinataire de l'export par e-mail" />
        <button className="btn" data-testid="btn-export-email" disabled={busy}
          onClick={() => run(
            () => fx.exportEmail({ date_from: exp.date_from, date_to: exp.date_to, format: exp.format, email: exp.email }),
            exp.email ? `Export envoyé à ${exp.email}.` : 'Export envoyé à vos adresses admin.')}>✉ Envoyer par e-mail</button>
      </div>

      <div className="wrap">
        {flash && <div className="nt ok" data-testid="flash">{flash}</div>}

        {anomalies && anomalies.count > 0 && (
          <div className="nt ba" data-testid="alerte-anomalies" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span>⚠️ <b>{anomalies.count} encaissement{anomalies.count > 1 ? 's' : ''} sans facture</b> — un paiement a été encaissé mais sa facture n'a pas été générée.</span>
            <div className="sp" />
            <button className="btn btn-s btn-p" data-testid="btn-reconcilier" disabled={busy}
              onClick={() => run(() => fx.reconcilier(), 'Factures manquantes régénérées.')}>Régénérer les factures manquantes</button>
          </div>
        )}

        <div className="cts" data-testid="compteurs-factures">
          <div className="ct mo"><div className="v mono">{eur0(c.encaisse_mois)}</div><div className="l">encaissé ce mois</div></div>
          <div className="ct"><div className="v mono">{eur0(c.en_attente)}</div><div className="l">en attente</div></div>
          <div className={`ct ${c.en_retard > 0 ? 'al' : ''}`}><div className="v mono">{eur0(c.en_retard)}</div><div className="l">en retard</div></div>
          <div className="ct"><div className="v mono">{eur0(c.avoirs)}</div><div className="l">avoirs</div></div>
        </div>

        <div className="tb" data-testid="onglets-factures">
          <button className={`tab ${tab === 'factures' ? 'on' : ''}`} data-testid="tab-factures" onClick={() => setTab('factures')}>Factures</button>
          <button className={`tab ${tab === 'impayes' ? 'on' : ''}`} data-testid="tab-impayes" onClick={() => setTab('impayes')}>
            Impayés {imp && imp.nb_clients > 0 ? `(${imp.nb_clients})` : ''}
          </button>
        </div>

        {tab === 'factures' && (
          <FacturesTab data={data} f={f} setF={setF} busy={busy} nav={nav}
            onPdf={(id) => run(() => fx.openPdf(id), 'PDF ouvert.')}
            onRenvoyer={(id) => run(() => fx.renvoyer(id), 'Facture renvoyée au client.')}
            onModal={(kind, facture) => setModal({ kind, facture })} />
        )}
        {tab === 'impayes' && (
          <ImpayesTab imp={imp} busy={busy} nav={nav}
            onRelanceAll={() => run(() => fx.relancerImpayes({}), 'Relances envoyées.')}
            onRelanceClient={(email) => run(() => fx.relancerImpayes({ client_email: email }), 'Relance envoyée.')} />
        )}
      </div>

      {modal && <ActionModal modal={modal} busy={busy} onClose={() => setModal(null)}
        onReglee={(mode) => run(() => fx.marquerReglee(modal.facture.id, mode), 'Facture marquée réglée.')}
        onAvoir={(montant, motif) => run(() => fx.avoir(modal.facture.id, { montant, motif }), 'Avoir créé.')}
        onRembourser={(montant) => run(() => fx.rembourser(modal.facture.id, { montant }), 'Remboursement traité.')}
        onRemboursementFait={() => run(() => fx.marquerRembourse(modal.facture.id), 'Remboursement manuel confirmé.')} />}
    </>
  );
}

function FacturesTab({ data, f, setF, busy, nav, onPdf, onRenvoyer, onModal }) {
  const rows = data.factures;
  return (
    <div className="bk" data-testid="bloc-factures">
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', padding: 12, alignItems: 'center', borderBottom: '1px solid var(--line)' }}>
        <select data-testid="filtre-type" value={f.type} onChange={(e) => setF({ ...f, type: e.target.value, page: 1 })}>
          {TYPE_FILTERS.map((t) => <option key={t.k} value={t.k}>{t.l}</option>)}
        </select>
        <select data-testid="filtre-statut" value={f.statut} onChange={(e) => setF({ ...f, statut: e.target.value, page: 1 })}>
          {STATUT_FILTERS.map((t) => <option key={t.k} value={t.k}>{t.l}</option>)}
        </select>
        <input placeholder="Rechercher (n°, client…)" data-testid="filtre-recherche" value={f.q}
          onChange={(e) => setF({ ...f, q: e.target.value, page: 1 })} style={{ minWidth: 200 }} />
        <input type="date" data-testid="filtre-from" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value, page: 1 })} />
        <input type="date" data-testid="filtre-to" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value, page: 1 })} />
      </div>

      {rows.length === 0 ? <div className="empty">Aucune facture pour ces critères.</div> : (
        <table data-testid="table-factures">
          <thead>
            <tr>
              <th>Numéro</th><th>Type</th><th>Client</th><th>Date</th>
              <th className="nu">Montant</th><th className="nu">Payé</th><th className="nu">Restant</th>
              <th>Statut</th><th>Mode</th><th />
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`facture-${r.id}`}>
                <td><b className="mono">{r.numero}</b></td>
                <td>{r.libelle_type}</td>
                <td style={{ cursor: 'pointer' }} onClick={() => nav(`/pilotage/dossier/${r.quote_id}`)}>
                  {r.client_nom} <span className="mono" style={{ color: 'var(--t3)' }}>· {r.quote_numero}</span>
                </td>
                <td className="mono">{dfr(r.date_emission)}</td>
                <td className="nu">{eur(r.montant)}</td>
                <td className="nu" style={{ color: 'var(--gr)' }}>{eur(r.montant_paye)}</td>
                <td className="nu" style={{ color: r.reste > 0.01 ? 'var(--ru)' : 'inherit' }}>{eur(r.reste)}</td>
                <td>
                  <span className={`bg ${STATUT_BADGE[r.statut] || 'bg-n'}`}>{r.libelle_statut}{r.jours_retard > 0 ? ` · ${r.jours_retard}j` : ''}</span>
                  {r.remboursement && r.remboursement.statut === 'a_rembourser' && <span className="bg bg-r" style={{ marginLeft: 4 }} data-testid={`fac-remb-manuel-${r.id}`}>à rembourser (virement)</span>}
                  {r.remboursement && r.remboursement.statut === 'erreur_reessayable' && <span className="bg bg-r" style={{ marginLeft: 4 }} data-testid={`fac-remb-erreur-${r.id}`}>remb. échec — réessayer</span>}
                  {((r.remboursement && r.remboursement.statut === 'rembourse') || (r.dossier_rembourse && !r.remboursement)) && <span className="bg bg-n" style={{ marginLeft: 4 }} data-testid={`fac-rembourse-${r.id}`}>remboursé</span>}
                </td>
                <td>{r.mode_paiement}</td>
                <td className="nu">
                  <div style={{ display: 'inline-flex', gap: 4, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                    <button className="btn btn-s" data-testid={`fac-pdf-${r.id}`} disabled={busy} onClick={() => onPdf(r.id)}>PDF</button>
                    <button className="btn btn-s" data-testid={`fac-renvoyer-${r.id}`} disabled={busy} onClick={() => onRenvoyer(r.id)}>Renvoyer</button>
                    {r.type !== 'avoir' && r.reste > 0.01 && (
                      <button className="btn btn-s btn-g" data-testid={`fac-regler-${r.id}`} disabled={busy} onClick={() => onModal('reglee', r)}>Marquer réglée</button>
                    )}
                    {r.type !== 'avoir' && <button className="btn btn-s" data-testid={`fac-avoir-${r.id}`} disabled={busy} onClick={() => onModal('avoir', r)}>Avoir</button>}
                    {r.type !== 'avoir' && r.montant_paye > 0.01 && (
                      <button className="btn btn-s btn-r" data-testid={`fac-rembourser-${r.id}`} disabled={busy} onClick={() => onModal('rembourser', r)}>Rembourser</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {data.pages > 1 && (
        <div style={{ display: 'flex', gap: 8, padding: 12, alignItems: 'center', justifyContent: 'center' }}>
          <button className="btn btn-s" data-testid="page-prev" disabled={f.page <= 1} onClick={() => setF({ ...f, page: f.page - 1 })}>← Précédent</button>
          <span className="mono">Page {data.page} / {data.pages}</span>
          <button className="btn btn-s" data-testid="page-next" disabled={f.page >= data.pages} onClick={() => setF({ ...f, page: f.page + 1 })}>Suivant →</button>
        </div>
      )}
    </div>
  );
}

function ImpayesTab({ imp, busy, nav, onRelanceAll, onRelanceClient }) {
  if (!imp) return <div className="load">Chargement…</div>;
  return (
    <div className="bk" data-testid="bloc-impayes">
      <div className="bh">
        <h2 data-testid="impayes-total">{eur(imp.total_a_recouvrer)} à recouvrer · {imp.nb_clients} client{imp.nb_clients > 1 ? 's' : ''}{imp.montant_plus_30j > 0 ? ` · dont ${eur(imp.montant_plus_30j)} de plus de 30 jours` : ''}</h2>
        <div className="sp" />
        {imp.nb_clients > 0 && <button className="btn btn-p" data-testid="btn-relancer-tous" disabled={busy} onClick={onRelanceAll}>Relancer tous les retards</button>}
      </div>
      {imp.clients.length === 0 ? <div className="empty">Aucun impayé. Tout est encaissé. 🎉</div> : imp.clients.map((cl, i) => (
        <div className="rw" key={i} data-testid={`impaye-${i}`}>
          <div className="gw" style={{ cursor: cl.factures[0] ? 'pointer' : 'default' }} onClick={() => cl.factures[0] && nav(`/pilotage/dossier/${cl.factures[0].quote_id}`)}>
            <div className="t">{cl.client_nom || cl.client_email}</div>
            <div className="m">{cl.nb_factures} facture{cl.nb_factures > 1 ? 's' : ''} · plus ancienne : {cl.plus_ancienne_jours} jour{cl.plus_ancienne_jours > 1 ? 's' : ''}{cl.client_telephone ? ` · ${cl.client_telephone}` : ''}</div>
          </div>
          <div className="am" style={{ color: 'var(--ru)' }}>{eur(cl.total_du)}</div>
          <div className="ac">
            {cl.client_telephone && <a className="btn btn-s" href={`tel:${cl.client_telephone}`} data-testid={`impaye-tel-${i}`}>📞</a>}
            <button className="btn btn-s btn-g" data-testid={`impaye-relancer-${i}`} disabled={busy || !cl.client_email} onClick={() => onRelanceClient(cl.client_email)}>Relancer</button>
          </div>
        </div>
      ))}
    </div>
  );
}

function ActionModal({ modal, busy, onClose, onReglee, onAvoir, onRembourser, onRemboursementFait }) {
  const { kind, facture } = modal;
  const [mode, setMode] = useState('virement');
  const [montant, setMontant] = useState(String(kind === 'avoir' ? facture.montant : facture.montant_paye || facture.montant || 0));
  const [motif, setMotif] = useState('');
  const remb = facture.remboursement;

  const titles = { reglee: 'Marquer la facture réglée', avoir: 'Créer un avoir', rembourser: 'Rembourser' };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}
      data-testid="facture-modal" onClick={onClose}>
      <div className="bk" style={{ width: 420, maxWidth: '92vw' }} onClick={(e) => e.stopPropagation()}>
        <div className="bh"><h2>{titles[kind]} — {facture.numero}</h2></div>
        <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {kind === 'reglee' && (
            <div className="f">
              <label>Mode de paiement</label>
              <select data-testid="modal-mode" value={mode} onChange={(e) => setMode(e.target.value)}>
                <option value="virement">Virement</option>
                <option value="cheque">Chèque</option>
                <option value="especes">Espèces</option>
                <option value="cb">Carte</option>
              </select>
            </div>
          )}
          {(kind === 'avoir' || kind === 'rembourser') && (
            <div className="f">
              <label>Montant (€)</label>
              <input type="number" data-testid="modal-montant" value={montant} onChange={(e) => setMontant(e.target.value)} />
            </div>
          )}
          {kind === 'avoir' && (
            <div className="f">
              <label>Motif</label>
              <input data-testid="modal-motif" value={motif} onChange={(e) => setMotif(e.target.value)} placeholder="Raison de l'avoir" />
            </div>
          )}
          {kind === 'rembourser' && (
            <div className="nt">💳 Remboursement Stripe sur la carte d'origine. Le repli « à rembourser par virement » ne se déclenche qu'en cas de refus avéré de Stripe (ex. délai dépassé). Une erreur temporaire reste réessayable.</div>
          )}
          {kind === 'rembourser' && remb && remb.statut === 'a_rembourser' && (
            <div className="nt wa" data-testid="modal-remb-manuel">
              À rembourser par virement : <b>{eur(remb.montant_a_rembourser_manuel)}</b>.
              <button className="btn btn-s btn-g" style={{ marginLeft: 8 }} data-testid="modal-remb-fait" disabled={busy} onClick={onRemboursementFait}>Marquer remboursé</button>
            </div>
          )}
          {kind === 'rembourser' && remb && remb.statut === 'erreur_reessayable' && (
            <div className="nt ba" data-testid="modal-remb-erreur">
              ⚠️ Erreur temporaire Stripe sur <b>{eur(remb.montant_a_reessayer)}</b> — aucun débit manuel imposé. Cliquez « Rembourser » pour réessayer.
            </div>
          )}
          {kind === 'rembourser' && remb && remb.montant_rembourse_carte > 0 && (
            <div className="nt ok" data-testid="modal-remb-carte">✓ Déjà remboursé sur la carte : <b>{eur(remb.montant_rembourse_carte)}</b>.</div>
          )}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn btn-s" data-testid="modal-annuler" onClick={onClose}>Annuler</button>
            {kind === 'reglee' && <button className="btn btn-g" data-testid="modal-confirmer" disabled={busy} onClick={() => onReglee(mode)}>Confirmer</button>}
            {kind === 'avoir' && <button className="btn btn-g" data-testid="modal-confirmer" disabled={busy} onClick={() => onAvoir(parseFloat(montant), motif)}>Créer l'avoir</button>}
            {kind === 'rembourser' && <button className="btn btn-r" data-testid="modal-confirmer" disabled={busy} onClick={() => onRembourser(parseFloat(montant))}>Rembourser</button>}
          </div>
        </div>
      </div>
    </div>
  );
}
